const newModel = () => {
    return {
        loaiDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        loaiDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        loaiDenId: item.loaiDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        loaiDenId: item.loaiDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        loaiDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        loaiDenId: item.loaiDenId,
        ten: item.ten,
        chieuSang: item.chieuSang,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        loaiDenId: null,
        ten: null,
        chieuSang: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const loaiDenModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


